import React, { useState, useContext, useRef } from "react";
import { Form, Button, Container, Card, Alert, InputGroup } from "react-bootstrap";
import { AuthContext } from "../../contexts/AuthContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUserLock } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import { FormLoginInterface } from "../../interfaces";
import { MakeMessageError } from "../../components/Components";



const initial: FormLoginInterface = {
    email: '',
    password: '',
}

const Login: React.FC = () => {
    const authContext = useContext(AuthContext);
    const [usuarioForm, setUsuarioForm] = useState<FormLoginInterface>(initial);
    const btnLogin = useRef<HTMLButtonElement>(null);
    const [showPassword, setShowPassword] = useState<boolean>(false);

    const handleChange = (e: any) => {
        const { name, value } = e.target;
        setUsuarioForm({ ...usuarioForm, [name]: value });
        authContext?.clearError(name);
    }

    const handleLogin = async (e: React.FormEvent) => {
        e.preventDefault();
        if (authContext) {
            btnLogin.current?.setAttribute('disabled', 'disabled');

            await authContext.login(usuarioForm.email, usuarioForm.password);
            btnLogin.current?.removeAttribute('disabled');

        }
    }

    return (
        <div style={{
            alignItems: 'center', backgroundColor: '#e9ecef', 'display': 'flex',
            flexDirection: 'column', 'height': '100vh', justifyContent: 'center'
        }}>

            <Container className="justify-content-center" style={{ maxWidth: '400px', }}>

                <Alert variant="danger" show={authContext?.showError}
                    onClose={() => authContext?.changeShowError(false)} dismissible>
                    <span>{authContext?.showMessageError}</span>
                </Alert>

                <Form onSubmit={handleLogin}>
                    <Card style={{ borderTop: '3px solid #007bff' }}>
                        <Card.Header className="py-3 text-center fw-bold card-outline-primary">
                            Informe suas credenciais
                        </Card.Header>
                        <Card.Body>
                            <Form.Group className="mb-3" controlId="email">
                                <Form.Label>E-mail:</Form.Label>
                                <Form.Control type="text" name="email"
                                    value={usuarioForm.email}
                                    onChange={handleChange}
                                    className={`${authContext?.errors?.email?.length !== undefined && authContext?.errors?.email?.length>0 ? "is-invalid" : ""}`}
                                    autoFocus

                                />
                                <MakeMessageError errors={authContext?.errors} field="email" />

                            </Form.Group>

                            <Form.Group className="mb-3" controlId="password">
                                <Form.Label>Senha:</Form.Label>

                                <InputGroup className="input-group-flat">

                                    <Form.Control type={showPassword ? "text" : "password"} 
                                        value={usuarioForm.password}
                                        className={`border-end-0  ${authContext?.errors?.password?.length !== undefined && authContext?.errors?.password?.length>0 ? "is-invalid" : ""}`}
                                        name="password" onChange={handleChange} />
                                    

                                    <span className={`input-group-text border-start-0 bg-white ${authContext?.errors?.password?.length !== undefined &&  authContext?.errors?.password?.length > 0 ? "border-danger" : ""}`}  >
                                        <a
                                            href="#"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                setShowPassword(!showPassword);
                                            }}
                                        >
                                            <i className={`fas ${showPassword ? "fa-eye-slash" : "fa-eye"}`}></i>
                                        </a>
                                    </span>
                                </InputGroup>
                                <MakeMessageError errors={authContext?.errors} field="password" />
                            </Form.Group>
{/* 2 opcao de layout login
                            <FloatingLabel
                                    controlId="email"
                                    label="E-mail"
                                    className="mb-3"
                                    >
                                    <Form.Control type="email" placeholder="E-mail"  name="email"
                                        onChange={handleChange}
                                        className={`${authContext?.errors?.email?.length !== undefined && authContext?.errors?.email?.length>0 ? "is-invalid" : ""}`}
                                    />
                                <MakeMessageError errors={authContext?.errors} field="email" />
                                </FloatingLabel>
                            

                                <FloatingLabel controlId="password" label="Senha" className="mb-3"
                                >
                                    <Form.Control type={showPassword ? "text" : "password"} placeholder="Senha" name="password"
                                    onChange={handleChange} 
                                        className={` ${authContext?.errors?.password?.length !== undefined && authContext?.errors?.password?.length > 0 ? "is-invalid" : ""}`}
                                        />
                                    <MakeMessageError errors={authContext?.errors} field="password" />
                                </FloatingLabel> */}

                            

                            <div className="d-flex justify-content-between">
                                <a className="text-decoration-none" href="/forgot-password">Esqueci minha senha</a>
                                <Link to="/register" className="text-decoration-none">Assinatura</Link>
                            </div>

                        </Card.Body>
                        <Card.Footer className="d-grid gap-2">
                            <Button variant="primary" type="submit" ref={btnLogin}>
                                <FontAwesomeIcon icon={faUserLock} title="Entrar" /> Entrar

                            </Button>
                        </Card.Footer>
                    </Card>
                </Form>

            </Container>
        </div>
    );
}

export default Login;